import "./styles.scss"

//import React Composant 
import Footer from '../Footer';

function ThirdContainer(){
   return(
      <div className="third__container">
         <Footer />
      </div>
   )
}

export default ThirdContainer